import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

export type Language = "en" | "ar";

interface ILanguageSwitcher {
  value: Language;
  onChange: (language: Language) => void;
}

export default function LanguageSwitcher({ value, onChange }: ILanguageSwitcher) {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: Language | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="language selector"
      sx={{
        height: "32px",
        marginBottom: 0,
        "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
          borderLeft: "none",
        },
        "& .MuiToggleButton-root": {
          padding: "6px 16px",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "20px",
          textTransform: "none",
          borderColor: "text.light3",
          color: "text.dark",
          "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "white",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
          "&:hover": {
            backgroundColor: "text.tableColor",
          },
        },
      }}
    >
      <ToggleButton value="en" aria-label="english">
        EN
      </ToggleButton>
      <ToggleButton value="ar" aria-label="arabic">
        AR
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
